import { render, staticRenderFns } from "./DeptPicker.vue?vue&type=template&id=6119f1b2&scoped=true"
import script from "./DeptPicker.vue?vue&type=script&lang=js"
export * from "./DeptPicker.vue?vue&type=script&lang=js"
import style0 from "./DeptPicker.vue?vue&type=style&index=0&id=6119f1b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6119f1b2",
  null
  
)

export default component.exports